import React, { useEffect } from 'react'
import ModalContainer from '@/modern/components/ModalContainer'
import useModal from '@/modern/actions/useModal'
import useLeadInfo from '@/modern/actions/useLeadInfo'
import useSellerInfo from '@/modern/actions/useSellerInfo'

import {
  VideoChamadaSucessoModal,
  RedArea,
  MainText,
  Info,
  MainInfo,
  InfoText,
  FlexContainer,
  LeftColumn,
  RightColumn,
  GrayInfo,
  SellerInfo,
  SellerBadge,
  BoldInfo,
  DayOfWeek,
  ButtonContainer,
  Quit,
} from './style'
import { useTracking } from '@/modern/tracking/global/hooks/useTracking'
import createTrackingData from '@/modern/tracking/global/helpers/createTrackingData'
import { DATALAYER_PAGES } from '@/modern/tracking/pages'
import { getQueryParameter, getSeals, onClientSide } from '@/utils/utils'
import useAuth from '@/modern/actions/useAuth'

export default ({ ad }) => {
  const { modal, closeModal } = useModal('videoChamadaSucesso')
  const { leadInfo } = useLeadInfo('videoChamadaDate')
  const { day, formattedTime } = leadInfo
  const { sellerInfo } = useSellerInfo('badge')

  const { dispatchAnalyticsEvent } = useTracking()
  const { userIsAuth } = useAuth()

  useEffect(() => {
    if (modal && onClientSide()) {
      const { href, search } = window.location
      const seals = getSeals(ad)
      const customObjDatalayer = {
        site: {
          brandOrigin: getQueryParameter(search, 'origem') || 'webmotors',
        },
        user: {
          loginStatus: userIsAuth ? 1 : 2,
        },
        page: {
          url: href,
          trackingCode: {
            idcmp: getQueryParameter(search, 'idcmp'),
            idcmpint: getQueryParameter(search, 'idcmpint'),
            icid: getQueryParameter(search, 'icid'),
            lkid: getQueryParameter(search, 'lkid'),
          },
        },
      }

      const trackingData = createTrackingData(
        'customPageView',
        DATALAYER_PAGES.videoCallSchedulingSuccess,
        customObjDatalayer
      )

      dispatchAnalyticsEvent(trackingData)
    }
  }, [ad, dispatchAnalyticsEvent, modal, userIsAuth])

  const handleCloseModal = () => {
    closeModal()

    const { href, search } = window.location

    const trackingData = createTrackingData(
      'customPageView',
      DATALAYER_PAGES.adDetail,
      {
        page: {
          url: href,
          trackingCode: {
            idcmp: getQueryParameter(search, 'idcmp'),
            idcmpint: getQueryParameter(search, 'idcmpint'),
            icid: getQueryParameter(search, 'icid'),
            lkid: getQueryParameter(search, 'lkid'),
          },
        },
      }
    )

    dispatchAnalyticsEvent(trackingData)
  }

  return (
    <ModalContainer
      show={modal}
      useWhiteBox
      smaller
      onBgClick={() => handleCloseModal()}
    >
      <VideoChamadaSucessoModal>
        <RedArea>
          <MainText>Agendado</MainText>
          <Info>
            Fique de olho: vamos te mandar o link da Videochamada por e-mail ou
            por WhatsApp!
          </Info>
          <Info smaller>
            Seja pontual e aproveite para tirar todas as suas dúvidas. ;){' '}
          </Info>
        </RedArea>

        <MainInfo>
          <InfoText>Informações da videochamada:</InfoText>
          <FlexContainer>
            <LeftColumn>
              <GrayInfo>Sobre o vendedor:</GrayInfo>
              <SellerInfo>
                <SellerBadge badge={sellerInfo} />
                <BoldInfo smaller>{ad.Seller.FantasyName}</BoldInfo>
              </SellerInfo>
            </LeftColumn>

            <RightColumn>
              <GrayInfo>Agendamento:</GrayInfo>
              <BoldInfo>
                {day.day} de {day.month} | {formattedTime.formattedHour}:
                {formattedTime.formattedMinutes}
              </BoldInfo>
              <DayOfWeek>{day.fullNameDayOfTheWeek}</DayOfWeek>
            </RightColumn>
          </FlexContainer>

          <ButtonContainer>
            <Quit
              data-qa="btn_video_call_go_back"
              onClick={() => handleCloseModal()}
            >
              Voltar para anúncio
            </Quit>
          </ButtonContainer>
        </MainInfo>
      </VideoChamadaSucessoModal>
    </ModalContainer>
  )
}
